module.exports = "<div id=\"page-content-wrapper\">\r\n    <div class=\"container-fluid container-table\">\r\n\r\n        <div class=\"row\">\r\n            <div class=\"col-md-10\">\r\n                <h1>Thank you for submitting your order!</h1>\r\n                <p>A confirmation of your order has been emailed to you. Please forward to the treasurer or appropriate\r\n                    person for prompt payment. Thank you!</p>\r\n            </div>\r\n        </div>\r\n\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/campaign/campaign-final-order/campaign-final-order.component.html
// module id = 957
// module chunks = 8